var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconionicIosMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_ionic-ios-mail",
    "data-name": "Icon ionic-ios-mail",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 13.846,
    viewBox: "0 0 20 13.846",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_69684",
    "data-name": "Path 69684",
    d: "M23.212,10.343l-5.173,5.269a.093.093,0,0,0,0,.135l3.62,3.856a.624.624,0,0,1,0,.885.627.627,0,0,1-.885,0l-3.606-3.841a.1.1,0,0,0-.139,0l-.88.894a3.871,3.871,0,0,1-2.76,1.163,3.949,3.949,0,0,1-2.817-1.2l-.846-.861a.1.1,0,0,0-.139,0L5.981,20.488a.627.627,0,0,1-.885,0,.624.624,0,0,1,0-.885l3.62-3.856a.1.1,0,0,0,0-.135L3.538,10.343a.1.1,0,0,0-.163.067V20.954a1.543,1.543,0,0,0,1.538,1.538H21.837a1.543,1.543,0,0,0,1.538-1.538V10.411A.1.1,0,0,0,23.212,10.343Z",
    transform: "translate(-3.375 -8.646)",
    fill: "#4b4b4b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_69685",
    "data-name": "Path 69685",
    d: "M13.644,16.678a2.614,2.614,0,0,0,1.88-.788l7.543-7.678a1.511,1.511,0,0,0-.952-.337H5.178a1.5,1.5,0,0,0-.952.337l7.543,7.678A2.614,2.614,0,0,0,13.644,16.678Z",
    transform: "translate(-3.644 -7.875)",
    fill: "#4b4b4b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconionicIosMail);
export default __webpack_public_path__ + "static/media/Icon ionic-ios-mail.982324ec03ee3e1ca80e65819a4ed38d.svg";
export { ForwardRef as ReactComponent };